import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';
import { useAuth } from '../contexts/AuthContext';

const PaymentCancelled: React.FC = () => {
  const { user } = useAuth();
  const isLoggedIn = !!user;

  return (
    <div
      className="min-h-screen flex flex-col"
      style={{ background: 'linear-gradient(to bottom, #0c0d1f, #1b1324)' }}
    >
      <main className="flex-1 flex items-center justify-center px-6 py-12">
        <div className="max-w-lg w-full bg-white/5 backdrop-blur border border-white/10 rounded-3xl p-10 text-center shadow-2xl">
          <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-amber-500/10 text-amber-300">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="h-8 w-8">
              <path
                fillRule="evenodd"
                d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-1.5 5.625a.75.75 0 0 0-1.5 0v5.25a.75.75 0 0 0 1.5 0v-5.25Zm.75 9a.9.9 0 1 0 0 1.8.9.9 0 0 0 0-1.8Z"
                clipRule="evenodd"
              />
            </svg>
          </div>

          <h1 className="text-2xl font-semibold text-white mb-3">Payment Cancelled</h1>
          <p className="text-white/70 mb-8">
            No problem—your payment hasn't been processed. You can restart the checkout flow whenever you're ready.
          </p>

          <div className="space-y-4">
            <Link
              to="/payment"
              className="btn-adsmash-primary block w-full rounded-lg px-6 py-3 text-white font-semibold shadow-lg transition hover:opacity-90"
            >
              Try Again
            </Link>
            {isLoggedIn ? (
              <Link to="/dashboard" className="block text-sm text-white/60 hover:text-white transition">
                Back to dashboard →
              </Link>
            ) : (
              <Link to="/" className="block text-sm text-white/60 hover:text-white transition">
                Back to home →
              </Link>
            )}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PaymentCancelled;

